import { Container, PageHero } from "@/components/site/Primitives";
import { addHeadingIds, formatLegalLastUpdated, parseLegalHeadings } from "@/lib/legal/parse-headings";

type LegalDocumentViewProps = {
  title: string;
  contentHtml: string;
  lastPublishedAt: Date | string | null;
};

export function LegalDocumentView({ title, contentHtml, lastPublishedAt }: LegalDocumentViewProps) {
  const htmlWithIds = addHeadingIds(contentHtml);
  const headings = parseLegalHeadings(htmlWithIds);

  return (
    <>
      <PageHero title={title} />
      <section className="py-8 md:py-12">
        <Container>
          <div className="grid gap-10 lg:grid-cols-[260px_minmax(0,1fr)] lg:gap-16 xl:grid-cols-[280px_minmax(0,1fr)]">
            <aside className="lg:sticky lg:top-24 lg:self-start">
              <p className="text-sm font-semibold uppercase tracking-[0.18em] text-muted-foreground">
                Last updated · {formatLegalLastUpdated(lastPublishedAt)}
              </p>
              {headings.length > 0 ? (
                <nav className="mt-6 hidden lg:block">
                  <p className="text-sm font-semibold uppercase tracking-[0.18em] text-primary">On this page</p>
                  <ul className="mt-4 space-y-2 border-l border-border/60 pl-4">
                    {headings.map((heading) => (
                      <li key={heading.id}>
                        <a
                          href={`#${heading.id}`}
                          className="block text-base text-muted-foreground transition hover:text-gold"
                        >
                          {heading.text}
                        </a>
                      </li>
                    ))}
                  </ul>
                </nav>
              ) : null}
            </aside>
            <div
              className="legal-document prose prose-lg max-w-3xl prose-headings:scroll-mt-24 prose-headings:text-primary prose-p:text-foreground/85 prose-li:text-foreground/85 prose-a:text-gold prose-a:font-semibold prose-a:no-underline hover:prose-a:underline"
              dangerouslySetInnerHTML={{ __html: htmlWithIds }}
            />
          </div>
        </Container>
      </section>
    </>
  );
}
